import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import dayjs from 'dayjs';
import {
  CardDetails,
  Detail,
  Bookmark,
  Label,
  Line,
  Overlay,
  Mandatory,
  BadgeWrapepr,
  Expired,
} from './style';
import { convertDuration } from '../../../../utils/common';
import { Bottom, Categories, Container, Cover, Title } from '../style';
import { BOOKMARK_SET } from '../../../../app/redux/actions/bookmarks';
import Icon from '../../Icon';
import CourseActions from '../../CourseActions';
import theme from '../../../theme';
import { MODAL_OPEN } from '../../../../app/redux/actions';
import { ModalLeaveCourseId } from '../../Modals/ModalLeaveCourse';
import { ModalSurveyId } from '../../Modals/ModalSurvey';
import Text from '../../Text';
import Badge from '../../Badge';
import HtmlRaw from '../../HtmlRaw';
import { useHighlightText } from '../../../../utils/highlight';
// eslint-disable-next-line import/no-cycle

const CardCourses = ({
  item,
  onClick,
  setBookmark,
  className = '',
  showStatus = false,
  modalOpen,
}) => {
  const highlightText = useHighlightText;
  const coverRef = useRef(null);
  const [data, setData] = useState(item);
  const [isBookmark, setIsBookmark] = useState(item?.bookmarked);
  const [smallCover, setSmallCover] = useState(false);

  useEffect(() => {
    setData(item);
    setIsBookmark(item?.bookmarked);
  }, [item]);

  const handleOnClick = () => {
    if (onClick) onClick();
  };

  const handleOnclickBookmark = (e) => {
    setBookmark({ id: item?.id, action: !isBookmark });
    setIsBookmark(!isBookmark);
    e.stopPropagation();
  };

  useLayoutEffect(() => {
    if (coverRef.current?.clientWidth && coverRef.current.clientWidth <= 275) {
      setSmallCover(true);
    } else setSmallCover(false);
  }, [coverRef?.current?.clientWidth]);

  return (
    <Container className={className}>
      <Cover cover={data?.cover} onClick={handleOnClick} ref={coverRef}>
        <Overlay>
          <Bookmark onClick={handleOnclickBookmark}>
            <Icon
              size={20}
              type="star-01"
              fill={isBookmark ? theme().colors.link : 'none'}
            />
          </Bookmark>
          <BadgeWrapepr>
            <div>
              <Label className="small-cover">{data?.code}</Label>
              {data?.mandatory_course && (
                <Mandatory className="small-cover">Obbligatorio</Mandatory>
              )}
            </div>
            <Badge type="news">
              {data?.typology === 'course' ? 'Corso' : 'Evento'}
            </Badge>
          </BadgeWrapepr>
          <CardDetails className={smallCover ? 'small-cover' : ''}>
            {data?.typology === 'course' && (
              <>
                <Detail>
                  <Text type="b4" className="text-white">
                    {convertDuration(data?.duration, true)}
                  </Text>
                  <Icon type="clock" size={20} fill="none" />
                </Detail>
                <Line />
              </>
            )}
            <Detail>
              {data?.typology === 'course' ? (
                <>
                  <Text type="b4" className="text-white">
                    {data?.total_activities} Attività
                  </Text>
                  <Icon type="puzzle-piece-01" size={20} fill="none" />
                </>
              ) : (
                <>
                  <Text type="b4" className="text-white">
                    {data?.total_activities} Sessioni
                  </Text>
                  <Icon type="layers-three-01" size={20} fill="none" />
                </>
              )}
            </Detail>
            {data?.created && (
              <Detail className="last">
                {dayjs(data.created * 1000).format('YYYY')}
              </Detail>
            )}
          </CardDetails>
          {typeof data?.expiration_date === 'number' &&
            data?.expiration_date > 0 &&
            data.expiration_date < dayjs()?.unix() && (
              <Expired>
                <Text type="h2.5">SCADUTO</Text>
              </Expired>
            )}
        </Overlay>
      </Cover>
      <Bottom className="bottom">
        <Categories>
          {(data?.categories || []).slice(0, 3).map((category, index) => (
            <span key={`cat-${index}`}>
              {index === 0 ? '' : '- '}
              {category?.label}{' '}
            </span>
          ))}
        </Categories>
        <Title onClick={handleOnClick}>
          <Text type="h3" className="link" mb={16}>
            <HtmlRaw html={highlightText(data?.title)} />
          </Text>
        </Title>
        <CourseActions
          item={data}
          onClick={handleOnClick}
          showStatus={showStatus}
          onClickLeave={() =>
            modalOpen(ModalLeaveCourseId, {
              id: data?.id,
              title: data?.title,
            })
          }
          onClickSurvey={() =>
            modalOpen(ModalSurveyId, {
              id: data?.id,
              title: data?.title,
            })
          }
        />
      </Bottom>
    </Container>
  );
};

CardCourses.propTypes = {
  className: PropTypes.string,
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  showStatus: PropTypes.bool,
  // HOC (connect, state)
  setBookmark: PropTypes.func.isRequired,
  modalOpen: PropTypes.func.isRequired,
};

export default connect(
  (state) => ({}),
  (dispatch) => ({
    setBookmark: ({ id, action }) =>
      dispatch({
        type: BOOKMARK_SET._REQUEST,
        id,
        action,
        item_type: 'course',
      }),
    modalOpen: (id, payload = {}) =>
      dispatch({ type: MODAL_OPEN, id, payload }),
  })
)(CardCourses);
